export default __webpack_public_path__ + "static/media/hassan_ecran_adieux_salim_FR.a1a2f45f.png";